module.exports = __webpack_public_path__ + "img/git-logo.b38ca172.svg";